import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import withUser from './WithUser'

const PrivateRoute = ({
  component: Component,
  authUser,
  unsetUser,
  ...rest
}) => {
  const [accessExpired, setAccess] = useState(false)
  useEffect(() => {
    setAccess(new Date() > new Date(authUser.accessExpiration) ? true : false)
    if (accessExpired) unsetUser()

    // eslint-disable-next-line
  }, [])
  return (
    <Route
      {...rest}
      render={props =>
        authUser.access && !accessExpired ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/auth/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.any, // Todo: This is not the best, fix asap
  location: PropTypes.object,
  authUser: PropTypes.shape({
    access: PropTypes.string,
    accessExpiration: PropTypes.string
  }),
  unsetUser: PropTypes.func
}

export default withUser(PrivateRoute)
